import React from "react";
import "./AboutCard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

export default function AboutCard(props) {
  return (
    <Card style={{ width: "18rem" }}>
      <Card.Img
        variant="top"
        src={props.image}
        alt="bio-image"
        className="bio-image"
      />
      <Card.Body>
        <Card.Title>{props.member?.name}</Card.Title>
        <Card.Text>{props?.about}</Card.Text>
      </Card.Body>
      <ListGroup className="list-group-flush">
        <ListGroup.Item>
          <b>Responsibility: </b> {props?.responsibility}
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Total Commits: </b> {props.member?.commits}
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Total Issues: </b> {props.member?.issues}
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Total Merge Requests: </b> {props.member?.mergeRequests}
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Total Tests: </b> {props.member?.tests}
        </ListGroup.Item>
      </ListGroup>
    </Card>
    // <div className="card shadow-sm about-card" style={{ width: "18rem" }}>
    //   <img src={props.image} className="bio-image" alt="bio-image" />
    //   <div className="card-body">
    //     <h5 className="card-title">{props.member?.name}</h5>
    //     <p className="card-text">
    //       <b>Responsibility: </b> {props?.responsibility}
    //     </p>
    //     <p className="card-text">
    //       <b>About: </b> {props?.about}
    //     </p>
    //     <p className="card-text">
    //       <b>Total Commits: </b> {props.member?.commits}
    //     </p>
    //     <p className="card-text">
    //       <b>Total Issues: </b> {props.member?.issues}
    //     </p>
    //     <p className="card-text">
    //       <b>Total Merge Requests: </b> {props.member?.mergeRequests}
    //     </p>
    //     <p className="card-text">
    //       <b>Total Tests: </b> {props.member?.tests}
    //     </p>
    //   </div>
    // </div>
  );
}
